import React, { useState, useEffect } from "react";

function SetTokenHeader(Component, axios) {
  function WrappedComponent(props) {
    const [interceptor] = useState(
      axios.interceptors.request.use((config) => {
        const configObject = config;
        configObject.headers.Authorization = `Bearer ${sessionStorage.getItem(
          `authToken`
        )}`;
        return configObject;
      })
    );
    useEffect(
      () => () => {
        axios.interceptors.request.eject(interceptor);
      },
      []
    );

    return (
      <>
        <Component {...props} />
      </>
    );
  }
  return WrappedComponent;
}
export default SetTokenHeader;
